import { useEffect, useRef, useState } from "react";

/**
 * Las miniaturas, UNA url por fichero, estable mientras el fichero siga en la
 * lista y liberada al quitarlo. Con `URL.createObjectURL(f)` dentro del render
 * cada tecla de la nota creaba urls nuevas: la imagen se recargaba (parpadeo) y
 * las viejas no se liberaban nunca. Y al AÑADIR una foto solo se crea la suya:
 * las que ya estaban no se vuelven a cargar.
 *
 * Se crean DENTRO del efecto y la limpieza del desmontaje las libera todas y
 * vacía la caché: así aguanta el doble montaje del modo estricto de React.
 */
export function useObjectUrls(files: readonly File[]): string[] {
  const cache = useRef(new Map<File, string>());
  const [urls, setUrls] = useState<string[]>([]);
  useEffect(() => {
    const map = cache.current;
    const keep = new Set(files);
    for (const [f, u] of map) {
      if (!keep.has(f)) {
        URL.revokeObjectURL(u);
        map.delete(f);
      }
    }
    setUrls(
      files.map((f) => {
        let u = map.get(f);
        if (!u) {
          u = URL.createObjectURL(f);
          map.set(f, u);
        }
        return u;
      }),
    );
  }, [files]);
  useEffect(
    () => () => {
      for (const u of cache.current.values()) URL.revokeObjectURL(u);
      cache.current.clear();
    },
    [],
  );
  return urls;
}
